import styled from 'styled-components';

export const CenterContainer = styled.div`
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;

    h1 {
        color: #fff;
        font-size: 28px;
        margin-bottom: 90px;
    }
`;

export const Logo = styled.img`
    width: 380px;
    max-width: 95%;
    margin-bottom: 30px;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;

    label,
    input {
        display: block;
        text-align: center;
    }

    label {
        color: #fff;
        font-size: 24px;
        margin-bottom: 5px;
    }

    input {
        width: 350px;
        font-size: 22px;
        padding: 8px;
    }

    div {
        margin-bottom: 15px;
    }

    button {
        margin-top: 10px;
        font-size: 24px;
        padding: 10px 25px;
    }
`;

export const LoginBox = styled.div`
    border: 2px solid #fff;
    border-radius: 12px;

    padding: 40px;

    background: rgba(255, 255, 255, 0.05);

    display: flex;
    flex-direction: column;
    align-items: center;

    min-width: 450px;

    box-shadow: 0 0 20px rgba(255, 255, 255, 0.15);
`;
